<template>
    <div class="content">
        <home-header></home-header>
        <personal-center></personal-center>
        <text-order-page></text-order-page>
    </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import textOrderPage from './textOrder.vue'
import PersonalCenter from '@/common/components/PersonalCenter'
import common from "@/common/js/common.js";

export default {
    name: 'textbookOrder',
    components: {
        HomeHeader,
        PersonalCenter,
        textOrderPage
    },
    created() {
        if (this.$route.name !== 'myPersonalStudyFee' && localStorage.getItem('token')) {
            this.axios.get('/sys/login/userinfo').then(res => {
                let userInfo = res.result.userInfo
                userInfo.eduLogo = res.result.eduLogo || null
                userInfo.headTitle = res.result.headTitle
                userInfo.pageTitle = res.result.pageTitle
                document.title = `${userInfo.eduName} - ${userInfo.pageTitle}`
                this.common.setStorage('userInfo', userInfo)
                this.$store.commit('SET_USERINFO', userInfo)
                console.log('userInfo 教材订购')
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';
.content{
}
</style>


// WEBPACK FOOTER //
// src/pages/textbookOrder/index.vue